import React from 'react';
import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import PaymentForm from '../PaymentForm';
import BatchedTicketsForm from './BatchedTicketsForm';
import PhasedTicketsForm from './PhasedTicketsForm';
import TicketCatalogModeBanner from './TicketCatalogModeBanner';
import type { EventFormData } from '../EventFormContainer';

interface TicketsStepProps {
  eventId?: string;
  onReload?: () => void;
}

const TicketsStep: React.FC<TicketsStepProps> = ({ eventId, onReload }) => {
  const { watch } = useFormContext<EventFormData>();
  const mode = watch('ticketCatalogMode') || 'legacy';

  return (
    <Box>
      {eventId && (
        <TicketCatalogModeBanner
          eventId={eventId}
          mode={mode}
          onModeChanged={() => onReload?.()}
        />
      )}
      {mode === 'phased' && <PhasedTicketsForm eventId={eventId} onReload={onReload} />}
      {mode === 'batched' && <BatchedTicketsForm />}
      {mode === 'legacy' && <PaymentForm />}
    </Box>
  );
};

export default TicketsStep;
